
import React, { PropTypes } from 'react';

import './style.scss';

const ArticleImage = props => {

  return (
    <div className="ArticleImage">
      <img src={props.url} />;
    </div>
  );
};

ArticleImage.propTypes = {
  url: PropTypes.string
};

export default ArticleImage;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/ArticleOuter/Article/ArticleImage/index.js
 **/